import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=1fdf552e&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdf552e')) {
      api.createRecord('1fdf552e', component.options)
    } else {
      api.reload('1fdf552e', component.options)
    }
    module.hot.accept("./Aside.vue?vue&type=template&id=1fdf552e&", function () {
      api.rerender('1fdf552e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/layouts/Aside.vue"
export default component.exports